<template>
  <div>
    <v-row>
      <v-col cols="6">
        <v-card>
          <vue-apex-charts
            width="100%"
            type="bar"
            :options="options"
            :series="barSeries"
          ></vue-apex-charts>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card>
          <v-toolbar dark>
            <v-toolbar-title>
              Filter
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col>
                <v-select
                  v-model="model.companyId"
                  item-text="name"
                  item-value="companyId"
                  :items="companies"
                  outlined
                  clearable
                  dense
                  placeholder="Company"
                  label="Company"
                ></v-select>
                <v-select
                  v-model="model.role"
                  item-text="name"
                  item-value="value"
                  :items="roles"
                  outlined
                  clearable
                  dense
                  placeholder="Role"
                  label="Role"
                ></v-select>
                <v-text-field
                  v-model="model.firstname"
                  outlined
                  dense
                  placeholder="Firstname"
                  label="Firstname"
                ></v-text-field>
                <v-text-field
                  v-model="model.lastname"
                  outlined
                  dense
                  placeholder="Lastname"
                  label="Lastname"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn block outlined color="primary" @click="getFilteredResults()"
              >Search</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <base-table
          title="User Report"
          titleSingle="Report"
          :headers="headers"
          :items="reports"
          :loading="loading"
          canExport
          @get-items="getFilteredResults"
          @export="onExport"
        >
        </base-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import UserService from "@/services/UserService.js";
import ReportService from "@/services/ReportService.js";
import CompanyService from "@/services/CompanyService.js";
import BaseTable from "@/components/tables/BaseTable.vue";
import fileDownload from "js-file-download";
export default {
  components: { VueApexCharts, BaseTable },
  data() {
    return {
      model: {},
      tab: "",
      companies: [],
      locations: [],
      reports: [],
      loading: false,
      headers: [
        { text: "User Name", value: "name" },
        { text: "Company Name", value: "companyName" },
        { text: "Passed Induction", value: "passedGeneral" },
        { text: "Completed Date", value: "date" },
        { text: "Role", value: "roleDescription" }
      ],
      roles: [
        { name: "Administrator", value: "ADM" },
        { name: "Security", value: "SEC" },
        { name: "Visitor", value: "VIS" },
        { name: "Contractor", value: "CON" },
        { name: "Employee", value: "EMP" }
      ],
      options: {
        chart: {
          type: "bar",
          animations: {
            speed: 200
          }
        },
        dataLables: {
          enabled: false
        },
        theme: {},
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        colors: ["#546E7A", "#E91E63"],
        xaxis: {
          categories: ["Passed", "Failed"]
        }
      },
      roleReport: [],
      userId: "",
      users: [],
      companyReport: []
    };
  },
  computed: {
    barSeries() {
      const general = this.reports.filter(x => x.passedGeneral == true).length;
      const failed = this.reports.filter(x => x.passedGeneral == false).length;

      const result = [
        {
          names: ["Passed", "Failed"],
          data: [general, failed]
        }
      ];

      return result;
    }
  },
  created() {
    this.getFilteredResults(), this.getUsers(), this.getCompanies();
  },
  methods: {
    getUsers() {
      UserService.getUsers().then(response => {
        this.users = response;
      });
    },
    getCompanies() {
      CompanyService.getCompanies().then(response => {
        this.companies = response;
      });
    },
    async getFilteredResults() {
      this.reports = await ReportService.getFilteredResults(this.model);
      this.total = this.reports.length;
    },
    async onExport() {
      try {
        const file = await ReportService.export(this.model);

        fileDownload(
          new Blob([file.data], {
            type: file.extension ? file.extension : "undefined"
          }),
          "UserReportExport.xls"
        );
      } catch (error) {
        // do something
      }
    }
  }
};
</script>

<style scoped></style>
